<template>
  <div>
    <Modal :title="`「${project.name}」租户成员`" v-model="memberModal" width="1000">
      <Spin fix v-if="memberLoading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      </Spin>
      <Alert v-else-if="memberGetError" show-icon type="error">
        获取数据失败
      </Alert>
      <div v-else>
        <div v-for="(memberItem, index) in members" :key="index">
          <Form ref="memberForm" :model="memberItem" :rules="memberRules" inline>
            <Row>
              <FormItem prop="user" :label-width="50" label="用户">
                <Select v-model="memberItem.user" placeholder="用户" clearable style="width: 200px" @on-change="userChange">
                  <Option v-for="uItem in users" :key="uItem.id" :value="uItem.id">{{ uItem.name }}</Option>
                </Select>
              </FormItem>
              <FormItem prop="roles" :label-width="50" label="角色">
                <Select v-model="memberItem.roles" placeholder="角色" multiple clearable style="width: 400px">
                  <Option v-for="roleItem in roles" :key="roleItem.id" :value="roleItem.id">{{ roleItem.name }}</Option>
                </Select>
              </FormItem>
              <FormItem :label-width="5">
                <a v-on:click="removeMemberItem(index)">
                  <Icon type="md-close" size="15" />
                </a>
              </FormItem>
            </Row>
          </Form>
        </div>
        <Button icon="md-add" type="primary" size="small" style="margin: 6px 12px" @click="addMemberItem"></Button>
      </div>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="submit" :loading="memberSubmitting">提交</Button>
        <Button @click="memberModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getPrivateCloudRoleAssignments } from '@/api/private-cloud/role'
import { updateMemberPrivateCloudProject } from '@/api/private-cloud/project'

export default {
  name: 'project-member',
  data () {
    return {
      project: {},
      memberModal: false,
      memberLoading: false,
      memberGetError: false,
      memberSubmitting: false,
      members: [],
      memberRules: {
        user: { required: true, message: '', trigger: 'change', validator: this.validUserForm },
        roles: { required: true, message: '请选择授权的角色', type: 'array' }
      },
      users: [],
      roles: []
    }
  },
  methods: {
    // 获取角色分配情况
    getRoleAssignments (project, users, roles) {
      this.project = project
      this.users = users
      this.roles = roles
      this.members = []
      let data = {}
      this.memberModal = true
      this.memberLoading = true
      getPrivateCloudRoleAssignments({project_id: this.project.id}).then(res => {
        let result = res.data.role_assignments
        for (let i in result) {
          let userId = result[i].user.id
          if (data[userId]) {
            data[userId].push(result[i].role.id)
          } else {
            data[userId] = [result[i].role.id]
          }
        }
        for (let i in data) {
          this.members.push({
            user: i,
            roles: data[i]
          })
        }
        this.memberLoading = false
        this.memberGetError = false
      }).catch(res => {
        this.memberLoading = false
        this.memberGetError = true
        console.error(res.response)
      })
    },
    addMemberItem () {
      this.members.push({
        user: '',
        roles: []
      })
    },
    removeMemberItem (index) {
      this.members.splice(index, 1)
    },
    validUserForm (rule, value, callback) {
      let userIds = this.assignProjects.map(item => item.user)
      const oneUserIdIndex = userIds.indexOf(value)
      if (!value) {
        callback(new Error('请选择用户！'))
      } else if (oneUserIdIndex > -1 && oneUserIdIndex < userIds.length - 1) {
        if (userIds.indexOf(value, oneUserIdIndex + 1) > -1) {
          callback(new Error('不能重复选择此用户！'))
        }
      } else {
        callback()
      }
    },
    userChange () {
      for (let i in this.$refs.memberForm) {
        this.$refs.memberForm[i].validate()
      }
    },
    submit () {
      let allValid = true
      for (let i in this.$refs.memberForm) {
        this.$refs.memberForm[i].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
      }
      if (allValid) {
        let reqData = {
          users: this.members
        }
        this.memberSubmitting = true
        updateMemberPrivateCloudProject(reqData, this.project.id).then(res => {
          this.memberSubmitting = false
          if (res.data.have_error) {
            this.$Notice.warning({title: '部分成员修改异常, 请检查'})
          } else {
            this.memberModal = false
            this.$Notice.success({title: '操作成功'})
          }
        }).catch(res => {
          this.memberSubmitting = false
          console.log(res.response)
          this.$Notice.error({title: '操作失败'})
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
